import { Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { makeStyles } from "components/providers/makeStyles";

import { useEventHeaderStyles } from "../event/useEventHeaderStyles";
import { Breadcrumbs } from "../navigation/Breadcrumbs";
import { useEvent } from "../../routes/events/id/EventProvider";
import { useEventDivision } from "../../routes/events/id/divisions/eventDivisionId/EventDivisionProvider";
import { EventDivisionHeaderSkeleton } from "./EventDivisionHeaderSkeleton";
import { HeadingNav } from "../navigation/HeadingNav";
import { ChildEventDivisions } from "./ChildEventDivisions";
import { isDivisionTeamType } from "../../eventDivisions/helpers";
import { RankingsSeries } from "../event/RankingsSeries";
import { LinkSponsorTags } from "../sponsors/LinkSponsorTag";
import { trackingCategory } from "../../../utils/tracking";

const useStyles = makeStyles(theme => ({
    header: {
        marginTop: theme.spacing(2),
    },
}));
export const EventDivisionHeader = () => {
    const classes = { ...useEventHeaderStyles(), ...useStyles() };
    const { id, eventDivisionId } = useParams();
    const event = useEvent();
    const eventDivision = useEventDivision();

    if (!event || !eventDivision) return <EventDivisionHeaderSkeleton/>;

    const isTeams = isDivisionTeamType(eventDivision);
    const isHeatBasedWithRoundResults = !eventDivision?.formatDefinition?.runBased && eventDivision?.formatDefinition?.roundBased;
    const hasTeamLeaderboard = eventDivision?.formatDefinition?.teamLeaderboard;
    const sponsoredContents = eventDivision?.sponsoredContents;

    return (
        <div className={classes.container}>
            <Breadcrumbs
                className="no-background"
                tryToUseGoBack
                crumbs={[
                    { text: event.organisation.name, link: `/${event.organisation.shortName}` },
                    { text: event.name, link: `/events/${id}` },
                ]}
            />

            <Typography variant="h3" component="h1" className={classes.name}>{eventDivision.division.name}</Typography>

            {eventDivision.eventDivisions?.length > 0 && <ChildEventDivisions event={event} eventDivisions={eventDivision.eventDivisions}/>}

            <LinkSponsorTags sponsoredContents={sponsoredContents} clickTrackingCategory={trackingCategory.sponsorIntegrationAtDivision}/>

            <RankingsSeries/>

            <HeadingNav className={classes.header} links={[
                { label: "Draw", to: `/events/${id}/divisions/${eventDivisionId}` },
                !event.hideEntries && { label: isTeams ? "Teams" : "Athletes", to: `/events/${id}/divisions/${eventDivisionId}/entries` },
                isHeatBasedWithRoundResults && { label: "Round leaderboard", to: `/events/${id}/divisions/${eventDivisionId}/leaderboard` },
                hasTeamLeaderboard && { label: "Team leaderboard", to: `/events/${id}/divisions/${eventDivisionId}/team-leaderboard` },
                { label: "Result", to: `/events/${id}/divisions/${eventDivisionId}/result` }
            ]}/>
        </div>
    );
};
